import gql from 'graphql-tag'

export const projectAssignmentFragment = gql`
    fragment projectAssignmentFragment on ProjectAssignment{
        id
        hasDraft
        accommodation_room_number
        accommodation_not_required
    }
`

export const assignmentFragment = gql`
    fragment assignmentFragment on Assignment{
        id
        dayOfWeek
        date
        start_time
        end_time

        notification_pending
        notification_sent
        notification_sent_at
        assignments_summary_sent_at
        acceptedByUser
        deniedByUser
        maybeByUser
        hasAssignmentError
        hasAbsenceError
        canceled

        project_shift_id
        project_id
        project_assignment_id
        user_profile_id
        draft_assignment_id
    }
`

export const draftAssignmentFragment = gql`
    fragment draftAssignmentFragment on DraftAssignment{
        id
        dayOfWeek
        date
        start_time
        end_time

        project_shift_id
        project_id
        project_assignment_id
        user_profile_id
    }
`

export const assignmentErrorFragment = gql`
    fragment assignmentErrorFragment on AssignmentError{
        id
        created_at
        date
        message
        type
    }
`